import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  return (
    <footer className="bg-[#0B132B] text-white py-12" data-testid="main-footer" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_school-legacy/artifacts/lt30qar7_PHOTO-2024-09-19-11-44-58.jpg" 
              alt="Anjal Al-tarbyh Educational" 
              className="h-12 w-12 mb-4 rounded"
            />
            <h3 className="text-lg font-bold mb-2" style={{fontFamily: isRTL ? 'Cairo' : 'Cormorant Garamond'}}>{t('header.schoolName')}</h3>
            <p className="text-sm text-gray-300">{t('header.alumniAssociation')}</p>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-[#D4AF37]" style={{fontFamily: isRTL ? 'Cairo' : 'Cormorant Garamond'}}>{t('footer.quickLinks')}</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/programs" className="hover:text-[#D4AF37] transition-colors">{t('header.programs')}</Link></li>
              <li><Link to="/directory" className="hover:text-[#D4AF37] transition-colors">{t('header.directory')}</Link></li>
              <li><Link to="/news" className="hover:text-[#D4AF37] transition-colors">{t('header.news')}</Link></li>
              <li><Link to="/events" className="hover:text-[#D4AF37] transition-colors">{t('header.events')}</Link></li>
              <li><Link to="/contact" className="hover:text-[#D4AF37] transition-colors">{t('header.contact')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-[#D4AF37]" style={{fontFamily: isRTL ? 'Cairo' : 'Cormorant Garamond'}}>{t('footer.getInvolved')}</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/register" className="hover:text-[#D4AF37] transition-colors">{t('footer.registerAsAlumni')}</Link></li>
              <li><Link to="/admin" className="hover:text-[#D4AF37] transition-colors">{t('footer.adminLogin')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-[#D4AF37]" style={{fontFamily: isRTL ? 'Cairo' : 'Cormorant Garamond'}}>{t('footer.connectWithUs')}</h4>
            <div className="flex gap-4 items-center flex-wrap">
              <a
                href="https://www.tiktok.com/@anjal_school"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#D4AF37] transition-colors cursor-pointer"
                data-testid="social-tiktok"
                aria-label="TikTok @anjal_school"
                title="TikTok @anjal_school"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.45a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.1z"/>
                </svg>
              </a>
              <a
                href="https://www.snapchat.com/add/anjaldawadmi"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#D4AF37] transition-colors cursor-pointer"
                data-testid="social-snapchat"
                aria-label="Snapchat @anjaldawadmi"
                title="Snapchat @anjaldawadmi"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12.166.014c.075 0 .298-.005.521.001 1.286.036 2.629.395 3.815 1.18 1.169.774 2.057 1.853 2.638 3.139.413.918.572 1.836.604 2.832.034 1.077-.043 2.157-.099 3.232-.005.108-.012.218.018.32.062.21.302.255.494.291.262.046.529.06.79.115.207.044.498.082.677.214.331.246.341.642.092.967a1.91 1.91 0 0 1-.62.522 6.354 6.354 0 0 1-1.49.59c-.106.029-.169.094-.218.187-.084.16-.13.317-.16.494-.04.241-.193.443-.453.434-.39-.012-.776-.103-1.166-.106-.225-.001-.45.029-.671.07-.444.082-.819.272-1.155.554a4.25 4.25 0 0 1-2.025.939c-.353.063-.706.05-1.058.054-.087 0-.183-.005-.285-.012-1.073-.077-2.025-.394-2.834-1.087-.317-.272-.679-.444-1.099-.515-.328-.057-.66-.07-.99-.044-.347.026-.685.108-1.029.121-.328.012-.479-.176-.527-.481-.024-.151-.064-.296-.131-.434-.052-.105-.116-.171-.225-.205-.482-.149-.961-.305-1.39-.585-.21-.137-.43-.275-.583-.486a.717.717 0 0 1-.082-.776c.16-.273.494-.405.799-.475.243-.058.49-.078.733-.118.166-.027.36-.07.43-.276.06-.18.085-.366.077-.555l-.08-1.554c-.039-.86-.075-1.722-.041-2.583.072-1.795.665-3.34 1.952-4.625C7.733 1.103 9.33.275 11.245.06c.297-.034.595-.045.921-.046z"/>
                </svg>
              </a>
              <a
                href="mailto:anjal.edu.sa@gmail.com?subject=Inquiry%20from%20Website"
                className="hover:text-[#D4AF37] transition-colors cursor-pointer"
                data-testid="social-email"
                aria-label="Email anjal.edu.sa@gmail.com"
                title="anjal.edu.sa@gmail.com"
              >
                <Mail size={22} />
              </a>
              <a
                href="tel:+966533076966"
                className="hover:text-[#D4AF37] transition-colors cursor-pointer"
                data-testid="social-phone"
                aria-label="Phone +966 53 307 6966"
                title="+966 53 307 6966"
              >
                <Phone size={22} />
              </a>
            </div>
            <a
              href="mailto:anjal.edu.sa@gmail.com"
              className="inline-block mt-4 text-sm text-gray-300 hover:text-[#D4AF37] transition-colors"
              dir="ltr"
              data-testid="footer-email-text"
            >
              anjal.edu.sa@gmail.com
            </a>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-sm text-gray-400">
          <p className="mb-1">{t('footer.copyright')}</p>
          <p className="font-semibold text-[#D4AF37] mb-4">{t('footer.allRightsReserved')}</p>
          <div className="flex justify-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_school-legacy/artifacts/3rbgc55e_10CB2C88-4911-4FE2-A48C-32F7838E87CC.png" 
              alt="Jumanah Abdullah" 
              className="h-24 w-auto object-contain"
              data-testid="footer-personal-logo"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;